import React from 'react'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Modal from 'components/Luxkit/Modal/Modal'
import InlineBulletList from 'components/utils/InlineBulletList'
interface Props {
  amenity: App.CruiseShipAmenityItem;
}

function CruiseShipAmenitiesModal({ amenity }: Props) {
  return <Modal title={amenity.title}>
    <BodyText variant="medium" weight="normal">{amenity.description}</BodyText>

    <InlineBulletList>
      {!amenity.description && amenity.listItems?.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </InlineBulletList>
  </Modal>
}

export default CruiseShipAmenitiesModal
